<style lang="less" scoped>
.tabs {
    width: 100%;
    //   flex-grow: 1;
    height: 55px;
    //   background: rgba(0, 0, 0, 0) !important;
    //   border: none !important;
    line-height: 55px;
    display: flex;
    flex-direction: row;
    color: #8F9BB3;
    border-bottom: 1px solid #EAF1FF;

    .tab_con {
        // width: 25%;
        // width: 75px;
        font-weight: 600;
        font-size: 12px;
        height: 55px;
        padding: 0 20px;
        text-align: center;
        white-space: nowrap;
        cursor: pointer;

        // padding-bottom: 10px;
        .selectActive {
            //   width: 30%;

            height: 55px;
            padding: 0 20px;
            margin: 0 auto;
            color: #000;
            //   white-space:nowrap;
            font-size: 14px;
            font-weight: 600;
            border-bottom: 3px solid #3291F8;
        }
    }
}
</style>

<template>
    <div class="list-container">
        <div class="list-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="listBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="list-content-div">
            <div class="tabs">
                <div v-for="(item, index) in tabList" :key="index" class="tab_con" @click="tabChange(item)">
                    <div :class="{ 'selectActive': item.value == tabSelect }">{{ item.label }}</div>
                </div>
            </div>
            <!-- 客户信息 -->
            <custDetail v-if="tabSelect == 1" />
            <!-- 充电信息 -->
            <chargeList v-if="tabSelect == 2" />
            <!-- 车俩信息 -->
            <vehicleManage v-if="tabSelect == 3" />
            <!-- 亲友信息 -->
            <relativesDetail v-if="tabSelect == 4" />
            <!-- 充电桩信息 -->
            <pileDetail v-if="tabSelect == 5" />
            <!-- <publicPileDetail v-if="tabSelect == 6"></publicPileDetail> -->
            <!-- 私桩共享信息 -->
            <sharedDetail v-if="tabSelect == 6" />
            <!-- 支付信息 -->
            <payDetail v-if="tabSelect == 7" />
            <!-- 积分信息 -->
            <integralDetail v-if="tabSelect == 8" />
            <!-- 共享订单信息 -->
            <sharedorderList v-if="tabSelect == 10" />
            <!-- 钱包信息 -->
            <walletInfo v-if="tabSelect == 9" />
            <!-- 共享开关信息 -->
            <sharedSwitchInfo v-if="tabSelect == 11" />
        </div>
    </div>
</template>

<script>
import custDetail from './cust-manage/cust-detail.vue';
import chargeList from './cust-manage/charge-list.vue';
import formMould from '../../components/form/index';
import vehicleManage from './cust-manage/vehicle-manage.vue';
import relativesDetail from './relativesDetail/relatives-friends-manage.vue';
import pileDetail from './pile-manage/pile-detaill.vue';
import sharedDetail from './cust-manage/shared-detail.vue';
import payDetail from './pay-detail.vue';
import integralDetail from './integral-detail.vue';
import sharedorderList from './shared-order-list.vue';
import walletInfo from './wallet-info.vue';
import publicPileDetail from '../charging-manage/pile-charge/public-charge-data/pile-datail.vue';
import sharedSwitchInfo from './cust-manage/shared-switch-info.vue';
// import pageConfig from './page-config';
export default {
    components: {
        custDetail,
        chargeList,
        vehicleManage,
        pileDetail,
        relativesDetail,
        payDetail,
        integralDetail,
        publicPileDetail,
        formMould,
        sharedDetail,
        sharedorderList,
        walletInfo,
        sharedSwitchInfo,
    },
    data() {

        return {
            listBreadCrumb: [{
                type: 'title',
                name: '用户信息管理',
            },
            {
                type: 'router',
                name: '客户信息',
                router: 'custList'
            },
            {
                type: 'title',
                name: '编辑'
            }],
            tabList: [],
            custTabList: [
                {
                    value: 1,
                    label: '客户信息'
                },
                {
                    value: 11,
                    label: '共享开关信息'
                },
                {
                    value: 2,
                    label: '充电信息'
                },
                {
                    value: 3,
                    label: '车俩信息'
                },
                {
                    value: 4,
                    label: '亲友信息'
                },
                {
                    value: 5,
                    label: '充电桩信息'
                },
                {
                    value: 6,
                    label: '私桩共享信息'
                },
                {
                    value: 10,
                    label: '私桩共享订单信息'
                },
                {
                    value: 7,
                    label: '支付信息'
                },
                {
                    value: 8,
                    label: '积分信息'
                },
                {
                    value: 9,
                    label: '钱包信息'
                },
            ],
            checkList: [],
            tabSelect: 1,
        }
    },
    methods: {
        //执行表格数据函数 角色状态下拉框
        init() {
            let _ = this;
            const custInfo = this.$store.state.custObj;
            // 使用 custTypeList[0] 来判断用户类型，保持原有逻辑不变
            const custType = custInfo.custTypeList && custInfo.custTypeList.length > 0
                ? custInfo.custTypeList[0]
                : custInfo.custType;

            if (custType === '桩主账号') {
                _.tabList = [
                    {
                        value: 1,
                        label: '客户信息'
                    },
                    {
                        value: 2,
                        label: '充电信息'
                    },
                    {
                        value: 3,
                        label: '车俩信息'
                    },
                    {
                        value: 4,
                        label: '亲友信息'
                    },
                    {
                        value: 5,
                        label: '充电桩信息'
                    },
                    {
                        value: 6,
                        label: '私桩共享信息'
                    },
                    {
                        value: 7,
                        label: '支付信息'
                    },
                    {
                        value: 8,
                        label: '积分信息'
                    },
                    {
                        value: 10,
                        label: '私桩共享订单信息'
                    },
                    {
                        value: 9,
                        label: '钱包信息'
                    },
                ];
            }
            if (custType === '共享管理账号') {
                _.tabList = [
                    {
                        value: 1,
                        label: '客户信息'
                    },
                    // {
                    //     value: 3,
                    //     label: '车俩信息'
                    // },
                    {
                        value: 11,
                        label: '共享开关信息'
                    },
                    {
                        value: 6,
                        label: '私桩共享信息'
                    },
                    {
                        value: 10,
                        label: '共享订单信息'
                    },
                    {
                        value: 9,
                        label: '钱包信息'
                    },
                ];
            }
            if (custType === '共享充电账号') {
                _.tabList = [
                    {
                        value: 1,
                        label: '客户信息'
                    },
                    {
                        value: 6,
                        label: '私桩共享信息'
                    },
                    {
                        value: 10,
                        label: '共享订单信息'
                    },
                ];
            }
        },
        tabChange(tab) {
            let _ = this
            _.listBreadCrumb[1].name = tab.label;
            _.tabSelect = tab.value;
        },
    },
    mounted() {
        this.tabSelect = this.$route.query.parent || '1'
        this.init();
    },
    destroyed() {
        this.$store.commit('setPileObj', null);
        this.$store.commit('setCustObj', null);
    }
}
</script>